import { setRem, initRem, resetRem } from "./rem";

export default {
  data() {
    return {
      isMobile: false,
    };
  },
  methods: {
    checkMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const mobileRegex =
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i;
      this.isMobile = mobileRegex.test(userAgent);

      // 如果是移动端，初始化 rem
      if (this.isMobile) {
        initRem();
      }
    },
    resetRem() {
      resetRem();
    },
  },
  created() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkMobile);
    // 组件销毁时移除 rem 相关监听
    if (this.isMobile) {
      window.removeEventListener("resize", setRem);
      window.removeEventListener("pageshow", setRem);
      this.resetRem();
    }
  },
};
